module.exports = __webpack_public_path__ + "static/media/professors_slide_1_mobile.8156fc5b.png";